export enum MycawFollowUpTypeformFieldRef {
  Concern1Level = 'S2_6_ebp_concern_1_level',
  Concern2Level = 'S2_7_ebp_concern_2_level',
  FeelingLevel = 'S2_8_ebp_feeling_level',
  OtherAspect = 'S3_1_ebp_other_aspect',
  MostImportantSupportAspect = 'S3_2_ebp_most_important_support_aspect',
}
